export const config = {
    backendUrl: process.env.NODE_ENV === 'production'
        ? 'https://resume-api.iptvdeutsch.com'  // Production URL
        : 'http://localhost:3000',          // Development URL
}; 